import { Playground } from '@playground';
import { Props } from 'docz';
import { Poscon } from "../../../../../packages/layout/src/components/poscon/poscon";
import { H3, P } from '@tpr/core';
import * as React from 'react';
export default {
  Playground,
  Props,
  Poscon,
  H3,
  P,
  React
};